export default __webpack_public_path__ + "static/look-3-alt-9442d3fdb8479ec560eca202d240f969.png";